// Reads the positioned text runs out of a PDF file, page by page, as
// { str, x0, x1, y } — y grows up the page, as in the PDF itself.
//
// pdf.js is loaded only when a PDF is actually imported. Its worker entry
// registers the worker code on window, so pdf.js runs it on the main thread
// and needs no separate worker file to be served (works the same in the
// browser and in the Electron build).
export const extractPdfTextPages = async (file) => {
  const [pdfjs] = await Promise.all([
    import("pdfjs-dist/legacy/build/pdf"),
    import("pdfjs-dist/legacy/build/pdf.worker.entry"),
  ]);
  const data = new Uint8Array(await file.arrayBuffer());
  const doc = await pdfjs.getDocument({ data, isEvalSupported: false })
    .promise;
  try {
    const pages = [];
    for (let pageNo = 1; pageNo <= doc.numPages; pageNo++) {
      const page = await doc.getPage(pageNo);
      const content = await page.getTextContent();
      pages.push({
        items: content.items
          .filter((item) => typeof item?.str === "string")
          .map((item) => ({
            str: item.str,
            x0: item.transform[4],
            x1: item.transform[4] + (item.width || 0),
            y: item.transform[5],
          })),
      });
    }
    return pages;
  } finally {
    doc.destroy();
  }
};
